import { Redirect } from 'react-router-dom'

import routes from 'src/routes'

const RedirectToLogin = (props) => {
    return (
        <Redirect
            to={{
                pathname: routes.login,
                state: { from: props.location },
            }}
        />
    )
}

export default RedirectToLogin
